

export const loading = (isLoading) => ({
  type: "LOADING_DASHBOARD",
  isLoading,
});

export const setRangeMonth = (range) => ({
  type: "SET_RANGE_MONTH",
  range,
});
